<template>
  <nav class="Fuell-Menu--content">
    <ul class="Fuell-Menu--items">
      <template v-for="(menuItem, index) in currentUserMenuTop">
        <li
          class="Fuell-Menu--items--item"
          :class="{ active: isRouteActive(menuItem.name) }"
          :key="index"
          v-tooltip="$t(`section_title_${menuItem.name}`)"
        >
          <router-link
            :to="menuItem.link"
            class="link"
          >
            <button class="icon">
              <div class="icon--container">
                <img
                  class="background"
                  :alt="`icon-menu-item-${menuItem.name}-icon-background`"
                  :src="menuItem.backgroundIcon"
                />
                <img
                  class="vector-icon"
                  :src="menuItem.icon"
                  :alt="`icon-menu-item-${menuItem.name}-icon-vector`"
                />
              </div>
            </button>
            <span class="tag">{{ $t(`section_title_${menuItem.name}`) }} </span>
          </router-link>
        </li>
      </template>
    </ul>
    <ul class="Fuell-Menu--items Fuell-Menu--items--bottom">
      <template v-for="menuItem in currentUserMenuBottom">
        <li
          class="Fuell-Menu--items--item"
          :class="{ active: isRouteActive(menuItem.name) }"
          :key="menuItem.name"
          v-tooltip="$t(`section_title_${menuItem.name}`)"
        >
          <router-link
            :to="menuItem.link"
            class="link"
          >
            <div v-if="menuItem.name === 'profile'">
              <div class="profile-icon">
                <user-name-badge
                  :userName="loggedUserName"
                  :thumbSizeClass="'Thumb--24'"
                  overrideMargins
                  :userAvatarId="currentUserAvatarId"
                  v-if="currentLoggedUser"
                />
              </div>
            </div>
            <button
              v-else
              class="icon"
            >
              <div class="icon--container">
                <img
                  class="background"
                  :alt="`icon-menu-item-${menuItem.name}-icon-background`"
                  :src="menuItem.backgroundIcon"
                />
                <img
                  class="vector-icon"
                  :alt="`icon-menu-item-${menuItem.name}-icon-vector`"
                  :src="menuItem.icon"
                />
              </div>

            </button>
            <span class="tag">{{ $t(`section_title_${menuItem.name}`) }} </span>
          </router-link>
        </li>
      </template>
    </ul>
  </nav>
</template>

<script>
import DashboardSideMenuMixin from './_mixins/_DashboardSideMenuMixin'
import UserNameBadge from '@/components/Commons/UserNameBadge'
import { USER_CARDS_TYPE } from '@/constants/userCardsType'
import { OFFICE_CARDS_TYPE } from '@/constants/officeCardsType'

export default {
  name: 'DashboardSideMenu',
  mixins: [DashboardSideMenuMixin],
  components: { UserNameBadge },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    officeFeatureCodeList () {
      return this.currentOfficeActivatedFeatures.map(item => item.feature.code)
    },
    currentUserMenuFilteredByOfficeFeatureCode () {
      let menu = []
      if (this.currentOfficeActivatedFeatures?.length) {
        menu = this.menuItems.filter(el => {
          let menuItemIsOfficeDependantAndMatchesActivatedFeatures = el.extraFeatures && this.officeFeatureCodeList.includes(el.officeFeatureCode)
          if (menuItemIsOfficeDependantAndMatchesActivatedFeatures) {
            return el
          } else {
            return !el.extraFeatures
          }
        })
      } else {
        menu = this.menuItems.filter(el => {
          if (el.name === 'users' && this.isUser) {
            return false
          }
          return !el.extraFeatures
        })
      }

      return menu
    },
    currentUserMenuFilteredByOfficeTypeCard () {
      let menu = []
      if (this.officeWithoutCards) {
        menu = this.currentUserMenuFilteredByOfficeFeatureCode.filter(el => !el.needs_office_card)
      } else {
        menu = [...this.currentUserMenuFilteredByOfficeFeatureCode]
      }
      return menu
    },

    currentUserMenuFilteredByRole () {
      if (!this.loggedUserRoles) return []
      let menuFilteredByRoles = []
      if (this.currentUserMenuFilteredByOfficeTypeCard.length > 0) {
        menuFilteredByRoles = this.currentUserMenuFilteredByOfficeTypeCard.filter(el => {
          return this.loggedUserRoles.some(role => el.roles.includes(role))
        })
      }

      return menuFilteredByRoles
    },

    currentUserMenuFilteredByUserCardType () {
      if (this.currentUserMenuFilteredByRole.length > 0) {
        if (this.userWithoutCards) {
          return this.currentUserMenuFilteredByRole.filter(el => {
            return !el.needs_card
          })
        } else {
          return (this.currentUserMenuFilteredByRole)
        }
      }
      return []
    },
    currentUserMenuWithoutAllowedRegularUserRoles () {
      return this.currentUserMenuFilteredByUserCardType.filter(el => !el.allowedRegularUserRoles)
    },
currentUserMenuFilteredByBudgetOwnerOrFunnelReviewer () {
  let menu = []

  if (this.isUser) {
    menu = this.currentUserMenuFilteredByUserCardType.filter(el => {
      if (el.allowedRegularUserRoles) {
        if (el.allowedRegularUserRoles.includes('REVIEWER') && this.userIsReviewer) {
          return true
        }
        if (el.allowedRegularUserRoles.includes('OWNER') && this.isOwnerOfBudget) {
          return true
        }
      } else {
        return true
      }
    }).filter(el => {
      if (el.name === 'users') {
        console.warn(' has feature', this.userIsOwnerAndHasInviteUserFeature)
        return this.userIsOwnerAndHasInviteUserFeature
      }
      return true
    })
  } else {
    menu = [...this.currentUserMenuFilteredByUserCardType]
  }

  return menu
},

    currentUserMenuTop () {
      return this.currentUserMenuFilteredByBudgetOwnerOrFunnelReviewer.filter(el => el.top_menu)
    },
    currentUserMenuBottom () {
      return this.currentUserMenuFilteredByBudgetOwnerOrFunnelReviewer.filter(el => !el.top_menu)
    },
    userIsReviewer () {
      return this.$store.getters['UsersStore/userLoggedIsReviewer']
    },
    userWithoutCards () {
      return this.$store.getters['UsersStore/userLogged'].userCardsType === USER_CARDS_TYPE.USER_CARDS_WITHOUT
    },
    officeWithoutCards () {
      return this.$store.getters['CompanyStore/currentCompany'].officeCardsType === OFFICE_CARDS_TYPE.OFFICE_CARDS_WITHOUT
    },
    loggedUserRoles () {
      return this.$store.getters['LoginStore/loggedUserRoles']
    },
    currentLoggedUser () {
      return this.$store.getters['UsersStore/userLogged'] || ''
    },
    loggedUserName () {
      return this.currentLoggedUser
        ? `${this.currentLoggedUser.firstName} ${this.currentLoggedUser.lastName}`
        : ''
    },
    currentUserFull () {
      return this.$store.getters['UsersStore/userLogged']
    },
    currentUserAvatarId () {
      return this.currentUserFull && this.currentUserFull.profilePicture
        ? this.currentUserFull.profilePicture.id
        : 0
    },
    currentOffice () {
      return this.$store.getters['CompanyStore/currentCompany'] && this.$store.getters['CompanyStore/currentCompany'].id
    },
    currentOfficeExtraFeatures () {
      return this.$store.getters['CompanyStore/currentCompany'].activatedFeatures && this.$store.getters['CompanyStore/currentCompany'].activatedFeatures.length > 0
    },
    currentOfficeActivatedFeatures () {
      return this.$store.getters['CompanyStore/currentCompany'].activatedFeatures
    },
    hasBenefits () {
      return this.currentOfficeActivatedFeatures?.find(el => el.code === 'FLEXIBLE_REMUNERATION') || false
    },
    hasOwnerInviteUsersFeature () {
      // OWNER_INVITE_USER

      return this.currentOfficeActivatedFeatures?.find(el => el.feature.code === 'OWNER_INVITE_USER') ?? false
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    },
    isOwnerOfBudget () {
      return this.$store.getters['UsersStore/userLoggedIsOwnerOfBudget']
    },
    userIsOwnerAndHasInviteUserFeature () {
      return this.hasOwnerInviteUsersFeature ? this.isUser && this.isOwnerOfBudget : false
    }
  },
  methods: {
    isRouteActive (route) {
      return this.$route.meta.section === route
    },
    logout () {
      this.$store.dispatch('LoginStore/logout')
      this.$store.dispatch('UsersStore/logout')
    }
  }

}
</script>
